import {
  useApiInfiniteQuery,
  useApiMutation,
  useApiQuery,
} from "../services/react-query";

export const useGetAllSpeakers = (params, queryOptions = {}) =>
  useApiQuery({
    queryOptions: { queryKey: ["speakers", params], ...queryOptions },
    fetchOptions: { url: "/speakers", method: "GET", params },
  });

export const useGetSpeakerById = (id) =>
  useApiQuery({
    queryOptions: { queryKey: ["speakers", id] },
    fetchOptions: { url: `/speakers/${id}`, method: "GET" },
  });

export const useGetPublicSpeakerById = (id) =>
  useApiQuery({
    queryOptions: { queryKey: ["speakers", "public", id] },
    fetchOptions: { url: `/public/speakers/${id}`, method: "GET" },
  });

export const useCreateSpeaker = () =>
  useApiMutation({
    invalidateQueryKeys: [["speakers"], ["speakersInf"]],
    fetchOptions: { url: "/speakers", method: "POST" },
    successMessage: { title: "Speaker successfully created" },
  });

export const usePatchSpeaker = (speakerId) =>
  useApiMutation({
    invalidateQueryKeys: [["speakers"], ["speakersInf"]],
    fetchOptions: { url: `/speakers/${speakerId}`, method: "PATCH" },
    successMessage: { title: "Speaker successfully updated" },
  });

export const useDeleteSpeaker = () =>
  useApiMutation({
    invalidateQueryKeys: [["speakers"], ["speakersInf"]],
    fetchOptions: { url: `/speakers`, method: "DELETE" },
    successMessage: { title: "Speaker successfully deleted" },
  });

export const useImportSpeakers = () => {
  return useApiMutation({
    invalidateQueryKeys: [["speakers"], ["speakersInf"]],
    fetchOptions: {
      url: "/speakers/import",
      method: "POST",
    },
    successMessage: {
      title: "Speakers were imported successfully",
    },
  });
};

export const useGetUserRecommendations = (speakerId) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["speakers", speakerId, "recommend-users"],
      enabled: !!speakerId,
    },
    fetchOptions: {
      url: `/speakers/${speakerId}/recommend-users`,
      method: "GET",
    },
  });

//public event speakers
export const useGetPublicSpeakersInfinite = (params) =>
  useApiInfiniteQuery({
    queryOptions: {
      queryKey: ["speakersInf", "public", params],
      enabled: !!params.eventId,
    },
    fetchOptions: {
      url: `/public/events/speakers`,
      method: "GET",
      params,
    },
  });
